(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22738,46796],{

/***/ 64677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/symbol/[symbol]",
      function () {
        return __webpack_require__(97798);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var global_MainLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53120);
/* harmony import */ var features_company_styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46796);

__webpack_require__(14473);
/* eslint-disable no-console */ 



var Company = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(63828), __webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(24513), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(37713), __webpack_require__.e(54392), __webpack_require__.e(7485), __webpack_require__.e(71682), __webpack_require__.e(74645), __webpack_require__.e(62114), __webpack_require__.e(96041), __webpack_require__.e(91727), __webpack_require__.e(15068), __webpack_require__.e(90010), __webpack_require__.e(65026), __webpack_require__.e(89238), __webpack_require__.e(11991), __webpack_require__.e(58151)]).then(__webpack_require__.bind(__webpack_require__, 11991));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11991)
            ];
        }
    }
});
var GuestFRCompany = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(63828), __webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(37713), __webpack_require__.e(85145), __webpack_require__.e(54392), __webpack_require__.e(7485), __webpack_require__.e(71682), __webpack_require__.e(74645), __webpack_require__.e(62114), __webpack_require__.e(96041), __webpack_require__.e(15068), __webpack_require__.e(13814), __webpack_require__.e(90010), __webpack_require__.e(89238), __webpack_require__.e(26895), __webpack_require__.e(47292), __webpack_require__.e(74463), __webpack_require__.e(97073)]).then(__webpack_require__.bind(__webpack_require__, 66092));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66092)
            ];
        }
    }
});
var CompanyGuestStream = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(63828), __webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(37713), __webpack_require__.e(57333), __webpack_require__.e(5406), __webpack_require__.e(85145), __webpack_require__.e(54392), __webpack_require__.e(7485), __webpack_require__.e(71682), __webpack_require__.e(74645), __webpack_require__.e(62114), __webpack_require__.e(96041), __webpack_require__.e(41232), __webpack_require__.e(15068), __webpack_require__.e(21066), __webpack_require__.e(13814), __webpack_require__.e(90010), __webpack_require__.e(26895), __webpack_require__.e(74463), __webpack_require__.e(13110)]).then(__webpack_require__.bind(__webpack_require__, 13110));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13110)
            ];
        }
    }
});
var SymbolPage = function(param) {
    var type = param.type, symbol = param.symbol, posts = param.posts, company = param.company, companyProfile = param.companyProfile, chart = param.chart, findData = param.findData, isLoggedIn = param.isLoggedIn;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var _$param = router.query.param;
    var activeTab = _$param === null || _$param === void 0 ? void 0 : _$param[0];
    if (!isLoggedIn) {
        var ref;
        var isCompanyStock = (company === null || company === void 0 ? void 0 : (ref = company.type_company) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "saham";
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(features_company_styled__WEBPACK_IMPORTED_MODULE_4__/* .GuestDocumentLayout */ .wE, {
            noBox: true,
            isCompanyStock: isCompanyStock,
            children: type === "FR" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GuestFRCompany, {
                symbol: symbol,
                company: company,
                chart: chart,
                finItem: findData === null || findData === void 0 ? void 0 : findData.fr_fitem
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompanyGuestStream, {
                symbol: symbol,
                posts: posts,
                company: company,
                isCompanyStock: isCompanyStock,
                companyProfile: companyProfile,
                chart: chart
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_MainLayout__WEBPACK_IMPORTED_MODULE_3__["default"], {
        maxWidth: 1000,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Company, {
            symbol: symbol,
            tab: activeTab
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (SymbolPage);


/***/ }),

/***/ 10567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97751);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-body {\n    padding: 20px;\n  }\n\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-3a0d262d-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
/* harmony default export */ __webpack_exports__["Z"] = (Box);


/***/ }),

/***/ 46796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jL": function() { return /* binding */ Banner; },
  "zj": function() { return /* binding */ CustomGuestCompanyBackground; },
  "zD": function() { return /* binding */ EmptyWrapper; },
  "uf": function() { return /* binding */ GuestChartWrapper; },
  "wE": function() { return /* binding */ GuestDocumentLayout; },
  "rT": function() { return /* binding */ GuestNavbar; },
  "Y5": function() { return /* binding */ GuestStreamWrapper; },
  "DT": function() { return /* binding */ RegisterButton; }
});

// UNUSED EXPORTS: FinancialWrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/statics/Box.js
var Box = __webpack_require__(10567);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/GuestLayout/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n\n  a {\n    color: ",
        ";\n    text-decoration: none;\n    margin: 8px 4px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 10px;\n  min-height: 100vh;\n\n  @media ",
        " {\n    padding: 20px 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        background-color: ",
        ";\n\n        @media ",
        " {\n          border-bottom: 1px solid ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        height: 72px;\n        padding: 22px 20px;\n\n        img {\n          height: 40px;\n          width: 75px;\n        }\n        button {\n          width: 99px;\n          height: 28px;\n        }\n        button.button-login p,\n        button.button-register p {\n          font-size: 12px;\n        }\n\n        @media ",
        " {\n          padding: 20px 10px;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding: 20px 10px;\n\n      img {\n        height: 40px;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 0;\n\n        @media ",
        " {\n          padding: 20px 30px;\n        }\n\n        @media ",
        " {\n          padding: 20px 10px;\n        }\n      "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 930px;\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}




var Footer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ecd13a1-0"
})(_templateObject(), color/* default.highempahis */.Z.highempahis);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ecd13a1-1"
})(_templateObject1(), color/* default.whiteSmoke */.Z.whiteSmoke, device/* default.tablet */.Z.tablet);
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5ecd13a1-2"
})(_templateObject4(), function(param) {
    var isGuestCompanyStock = param.isGuestCompanyStock;
    if (isGuestCompanyStock) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var HeaderFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5ecd13a1-3"
})(_templateObject7(), function(props) {
    // @ts-expect-error
    if (props.isGuestCompanyStock) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject5(), device/* default.laptop */.Z.laptop);
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject6());
});
var MainContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-5ecd13a1-4"
})(_templateObject10(), function(props) {
    // @ts-expect-error
    if (props.isGuestCompanyStock) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});


;// CONCATENATED MODULE: ./src/global/GuestLayout/index.tsx











var GuestLayout = function(param) {
    var children = param.children, _noBox = param.noBox, noBox = _noBox === void 0 ? false : _noBox, _noAuth = param.noAuth, noAuth = _noAuth === void 0 ? false : _noAuth, _isCompanyStock = param.isCompanyStock, isCompanyStock = _isCompanyStock === void 0 ? false : _isCompanyStock, _className = param.className, className = _className === void 0 ? "" : _className;
    var router = (0,next_router.useRouter)();
    var date = new Date();
    var year = date.getFullYear();
    var isGuestCompanyStock = isCompanyStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                isGuestCompanyStock: isGuestCompanyStock,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderFlex, {
                    align: "center",
                    direction: "row",
                    justify: "space-between",
                    // @ts-expect-error
                    mx: "auto",
                    isGuestCompanyStock: isGuestCompanyStock,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/stockbit.svg",
                                    alt: "Stockbit"
                                })
                            })
                        }),
                        !noAuth && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "row",
                            justify: "center",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/login",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            // @ts-expect-error
                                            mr: "16px",
                                            className: "button-login",
                                            mt: isGuestCompanyStock ? 0 : "8px",
                                            type: isGuestCompanyStock ? "default" : "borderless",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: isGuestCompanyStock ? "regular" : "bold",
                                                color: isGuestCompanyStock ? color/* default.highempahis */.Z.highempahis : color/* default.pinkSwan */.Z.pinkSwan,
                                                children: "Login"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "primary",
                                            className: "button-register",
                                            // @ts-expect-error
                                            mt: isGuestCompanyStock ? 0 : "8px",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                router.push("/register");
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                family: isGuestCompanyStock ? "regular" : "bold",
                                                color: color/* default.light */.Z.light,
                                                children: "Register"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContainer, {
                // @ts-expect-error
                mx: "auto",
                mb: "24px",
                isGuestCompanyStock: isGuestCompanyStock,
                children: noBox ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    style: {
                        width: "100%"
                    },
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                    children: [
                        "2013-",
                        year,
                        " Stockbit \xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/about",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "About"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/contact",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Contact"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://help.stockbit.com/id",
                            children: "Help"
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/rules",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "House Rules"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Terms"
                            })
                        }),
                        "\xb7",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: "Privacy"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
GuestLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBox: (prop_types_default()).bool,
    noAuth: (prop_types_default()).bool
};
GuestLayout.defaultProps = {
    noBox: false,
    noAuth: false
};
/* harmony default export */ var global_GuestLayout = (GuestLayout);

;// CONCATENATED MODULE: ./src/features/company/GuestCompanyBackground/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  margin-bottom: 20px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px;\n  border-bottom: solid 1px ",
        ";\n\n  h2 {\n    margin: 0;\n    font-size: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var MainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8106c47-0"
})(styled_templateObject(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);
var TitleWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8106c47-1"
})(styled_templateObject1(), color/* default.gainsboro */.Z.gainsboro, color/* default.black */.Z.black);
var BodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8106c47-2"
})(styled_templateObject2());
var ReadMore = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-b8106c47-3"
})(styled_templateObject3(), color/* default.primary */.Z.primary);


;// CONCATENATED MODULE: ./src/features/company/GuestCompanyBackground/index.tsx



var GuestCompanyBackground = function(param) {
    var companyProfile = param.companyProfile, _className = param.className, className = _className === void 0 ? "" : _className, onClickReadMore = param.onClickReadMore;
    var textBody = companyProfile.background;
    var isLongText = textBody.length > 636;
    if (isLongText) textBody = "".concat(textBody.slice(0, 636), "...");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    children: "Company Background"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    family: "regular",
                    size: "12px",
                    children: [
                        textBody,
                        " ",
                        isLongText && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadMore, {
                            onClick: function() {
                                return onClickReadMore(true);
                            },
                            children: "Read More"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var company_GuestCompanyBackground = (GuestCompanyBackground);

// EXTERNAL MODULE: ./src/features/company/Navbar/index.tsx + 2 modules
var Navbar = __webpack_require__(82603);
;// CONCATENATED MODULE: ./src/features/company/styled.ts

function company_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      height: calc(100% - 60px);\n      left: 0px;\n      margin: auto;\n      overflow-y: scroll;\n      padding: 20px;\n      position: fixed;\n      top: 60px;\n      z-index: 10;\n\n      @media ",
        " {\n        height: calc(100% - 100px);\n        top: 100px;\n        width: 100%;\n      }\n\n      @media ",
        " {\n        width: 100%;\n      }\n    "
    ]);
    company_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function company_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  padding-bottom: 20px;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    company_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function company_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 20px auto auto auto;\n  padding: 25px 0;\n  height: 320px;\n"
    ]);
    company_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function company_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    company_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0;\n\n  @media ",
        " {\n    padding: 0;\n  }\n\n  @media ",
        " {\n    background-color: ",
        ";\n    padding: 0;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 20px 20px;\n\n  @media ",
        " {\n    margin: 0 0 20px 0;\n  }\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0px 0 20px 0;\n    "
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding: 0 20px;\n\n        @media ",
        " {\n          padding: 0;\n        }\n      "
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fff;\n  padding: 12px 0;\n  margin-bottom: 20px;\n\n  @media ",
        " {\n    border: 1px solid ",
        ";\n    border-top: none;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}








// eslint-disable-next-line space-infix-ops
var FinancialWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2156a775-0"
})(company_styled_templateObject1(), function(param) {
    var fullscreen = param.fullscreen;
    return fullscreen && (0,styled_components_browser_esm/* css */.iv)(company_styled_templateObject(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop);
});
var EmptyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2156a775-1"
})(company_styled_templateObject2(), color/* default.light */.Z.light, color/* default.gainsboro */.Z.gainsboro);
var RegisterButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    type: "primary",
    as: "a"
}).withConfig({
    componentId: "sc-2156a775-2"
})(company_styled_templateObject3());
var Banner = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    type: "primary",
    as: "a"
}).withConfig({
    componentId: "sc-2156a775-3"
})(styled_templateObject4(), device/* default.tablet */.Z.tablet);
var GuestDocumentLayout = (0,styled_components_browser_esm/* default */.ZP)(global_GuestLayout).withConfig({
    componentId: "sc-2156a775-4"
})(styled_templateObject5(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet, device/* default.laptop */.Z.laptop, color/* default.whiteSmoke */.Z.whiteSmoke);
var CustomGuestCompanyBackground = (0,styled_components_browser_esm/* default */.ZP)(company_GuestCompanyBackground).withConfig({
    componentId: "sc-2156a775-5"
})(styled_templateObject6(), device/* default.tablet */.Z.tablet);
var GuestNavbar = (0,styled_components_browser_esm/* default */.ZP)(Navbar/* default */.Z).withConfig({
    componentId: "sc-2156a775-6"
})(styled_templateObject8(), function(param) {
    var isCompanyStock = param.isCompanyStock;
    return isCompanyStock && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject7());
});
var GuestStreamWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2156a775-7"
})(styled_templateObject10(), // @ts-expect-error
function(param) {
    var isCompanyStock = param.isCompanyStock;
    return isCompanyStock && (0,styled_components_browser_esm/* css */.iv)(styled_templateObject9(), device/* default.tablet */.Z.tablet);
});
var GuestChartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2156a775-8"
})(_templateObject11(), device/* default.tablet */.Z.tablet, color/* default.gainsboro */.Z.gainsboro);



/***/ }),

/***/ 47165:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/broker-flow/1.1.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["brokerflow"]) {
      return resolve(window.remoteLoading["brokerflow"])
    }

    var res, rej;
    window.remoteLoading["brokerflow"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["brokerflow"] !== 'undefined') {
      res(window["brokerflow"]);
      return resolve(window["brokerflow"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["brokerflow"] !== 'undefined') {
          res(window["brokerflow"]);
          return resolve(window["brokerflow"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "brokerflow"
    );
  }).then(function () {
    const proxy = {
      get: brokerflow.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          brokerflow.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        brokerflow.__initialized = true
      }
    }
    if (!brokerflow.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 16624:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.3.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 75218:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/1.1.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 2680:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.2/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 53166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/tradebook-chart/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["tradebookchart"]) {
      return resolve(window.remoteLoading["tradebookchart"])
    }

    var res, rej;
    window.remoteLoading["tradebookchart"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["tradebookchart"] !== 'undefined') {
      res(window["tradebookchart"]);
      return resolve(window["tradebookchart"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["tradebookchart"] !== 'undefined') {
          res(window["tradebookchart"]);
          return resolve(window["tradebookchart"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "tradebookchart"
    );
  }).then(function () {
    const proxy = {
      get: tradebookchart.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          tradebookchart.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        tradebookchart.__initialized = true
      }
    }
    if (!tradebookchart.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,88069,46819,97089,7648,80129,50299,51225,73216,2978,52134,92961,91036,54253,54005,33070,58928,76750,79931,35851,68577,14577,10733,88585,11977,74768,12786,77284,74915,49774,92888,40179], function() { return __webpack_exec__(64677); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);